import React, { useEffect, useState } from 'react'
import Modal from 'Common/Components/Modal';
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";
import Flatpickr from "react-flatpickr";
import { Common } from 'helpers/common';
import {
    deleteGSTRates ,
    addGSTRates,
    updateGSTRates
} from '../../../helpers/backend_helper';

import { Loader2, UploadCloud } from 'lucide-react';
import "flatpickr/dist/flatpickr.css";
import { GSTRateType } from 'types/GSTRateType';
import moment from 'moment';

type Props = { onHide: () => void; data: any, onSave: (result: any) => void }

const AddGTSRate: React.FC<Props> = ({ onHide, data, onSave }) => {

    const [gstRateData, setGTSRateData] = useState<GSTRateType>(data);
    const [isEdit, setIsEdit] = useState<boolean>(false);

    const [isSaving, setIsSaving] = useState<boolean>(false);
    const commonHelper = new Common();
    const [selectedFiles, setSelectedFiles] = React.useState<any>([])
    const [selectedImage, setSelectedImage] = useState<any>();

    const handleAcceptedFiles = (files: any) => {
        files.map((file: any) =>
            Object.assign(file, {
                preview: URL.createObjectURL(file),
                formattedSize: commonHelper.formatBytes(file.size),
            })
        )
        setSelectedFiles(files)
        setSelectedImage(files[0]);
        validation.setFieldValue('logo', 'htttp');
    }

    useEffect(() => {
        if (gstRateData?.id) {
            setIsEdit(gstRateData?.id>0);
            console.log(gstRateData);
           
        }
    }, [])

    // validation
    const validation: any = useFormik({
        enableReinitialize: true,
        initialValues: {
            hsnsac: (gstRateData && gstRateData.hsnsac) || '',
            description: (gstRateData && gstRateData.description) || '',
            gstRate: (gstRateData && gstRateData.gstRate) || '',
            effectiveDate: (gstRateData && moment(gstRateData.effectiveDate).format("DD MMMM ,YYYY")) || moment().format("DD MMMM ,YYYY"),
            isActive: (gstRateData && gstRateData.isActive) || true,
        },
        validationSchema: Yup.object({
            hsnsac: Yup.string()
                .required("Please Enter HSN/SAC !")
                .matches(/^\d{6}$|^\d{8}$/, "HSN/SAC must be either 6 or 8 digits")
                .test('is-valid-length', 'HSN/SAC must be either 6 or 8 digits', value => {
                    if (!value) return true; // Let required handle empty values
                    return value.length === 6 || value.length === 8;
                }),
            description: Yup.string().required("Please Enter Description !"),
            gstRate: Yup.string().required("Please Enter GST Rate !"),
            effectiveDate: Yup.string().required("Please Enter Effective Date !"),
            isActive: Yup.bool().required("Please choose yes or no!")
        }),

        onSubmit: async (values: any) => {
            setIsSaving(true);

                        
            if (isEdit && gstRateData) {
                try {
                    // update user
                    const updateData = {
                        ...values,
                        id: gstRateData.id,
                    };

                    var result = await updateGSTRates(updateData);
                    commonHelper.showSuccessMessage('GTSRate has been successfully updated.');
                    onSave(result.data);

                } catch (error) {
                    console.log('API-Error', error);
                    commonHelper.showErrorMessage(error as string);
                    setIsSaving(false);
                }

                setIsEdit(false);
            } else {
                // save new user

                try {
                    const newData = { ...values };
                    var result = await addGSTRates(newData);
                    commonHelper.showSuccessMessage('GTSRate has been successfully saved.');
                    onSave(result.data);
                } catch (error) {
                    console.log('API-Error', error);
                    commonHelper.showErrorMessage(error as string);
                    setIsSaving(false);
                }
            }
            setIsSaving(false);
        },

    });

    const handleStartDateChange = (selectedDates: any, dateStr: any, instance: any) => {
        console.log(dateStr)
        validation.setFieldValue('effectiveDate', moment(selectedDates[0]).format("DD MMMM ,YYYY"))
    }

    const maxLengthCheck = (object:any) => {
        if (object.target.value.length > object.target.maxLength) {
         object.target.value = object.target.value.slice(0, object.target.maxLength)
          }
        }
 
    return (
        <React.Fragment>
             <Modal.Header  className="bg-custom-200 dark:bg-custome-700 flex items-center justify-between p-4 border-b dark:border-zink-300/20"
                closeButtonClass="transition-all duration-200 ease-linear text-slate-400 hover:text-red-500">
                <Modal.Title className="text-16">{!!isEdit ? "Edit HSNSAC" : "Add HSNSAC"}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto bg-custom-50 dark:bg-custom-500/200">
                <form action="#!" onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                }}>
                    <div className="grid grid-cols-1 gap-5 lg:grid-cols-2 xl:grid-cols-6">
                        <div className="lg:col-span-2 xl:col-span-12">
                            <label htmlFor="hsnsac" className="inline-block mb-2 text-base font-medium">HSN SAC</label>
                            <input type="text" 
                                className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                                id="hsnsac"
                                name="hsnsac"
                                placeholder="Enter 6 or 8 digit HSN/SAC"
                                onChange={(e) => {
                                    const value = e.target.value.replace(/[^0-9]/g, '').slice(0, 8);
                                    validation.setFieldValue('hsnsac', value);
                                }}
                                onBlur={validation.handleBlur}
                                value={validation.values.hsnsac || ""}
                                maxLength={8}
                            />
                                
                            {validation.touched.hsnsac && validation.errors.hsnsac ? (
                                <div id="hsnsac-error" className="mt-1 text-sm text-red-500">{validation.errors.hsnsac}</div>
                            ) : null}
                        </div>
                        <div className="lg:col-span-2 xl:col-span-12">
                            <h6 className="mb-4 text-15">Description</h6>
                            <div className="ckeditor-classic text-slate-800">
                            <input className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                                    id="description"
                                    name="description"
                                    placeholder="Enter Description"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.description || ""}
                                ></input>
                                {validation.touched.description && validation.errors.description ? (
                                    <div id="title-error" className="mt-1 text-sm text-red-500">{validation.errors.description}</div>
                                ) : null}
                            </div>
                        </div>
                        <div className="lg:col-span-2 xl:col-span-12">
                            <label htmlFor="gstRate" className="inline-block mb-2 text-base font-medium">GST Rate</label>
                            <input type="number" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                                id="gstRate"
                                name="gstRate"
                                placeholder="GST Rate"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.gstRate || ""} />
                            {validation.touched.gstRate && validation.errors.gstRate ? (
                                <div id="gstRate-error" className="mt-1 text-sm text-red-500">{validation.errors.gstRate}</div>
                            ) : null}
                        </div>
                        <div className="lg:col-span-2 xl:col-span-12">
                            <label htmlFor="effectiveDate" className="inline-block mb-2 text-base font-medium">Effective Date</label>
                            <Flatpickr
                                id="effectiveDate"
                                options={{
                                    dateFormat: "d M, Y",
                                 }}
                                onChange={(date: any) => validation.setFieldValue("effectiveDate", moment(date[0]).format("DD MMMM ,YYYY"))}
                                value={validation.values.effectiveDate}
                                placeholder="Select Date"
                                className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                            />
                            {validation.touched.effectiveDate && validation.errors.effectiveDate ? (
                                <div id="effectiveDate-error" className="mt-1 text-sm text-red-500">{validation.errors.effectiveDate}</div>
                            ) : null}
                        </div>
                    </div>

                    <div className="flex justify-end gap-2 mt-4">
                        <button type="reset" data-modal-close="addDocuments" className="text-red-500 transition-all duration-200 ease-linear bg-white border-white btn hover:text-red-600 focus:text-red-600 active:text-red-600 dark:bg-zink-500 dark:border-zink-500" onClick={onHide}>Cancel</button>

                        {!isSaving ?
                            <button type="submit" className="text-white transition-all duration-200 ease-linear btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20">
                                {!!isEdit ? "Update HSNSAC" : "Add HSNSAC"}
                            </button>
                            : <button type="button" disabled className="flex items-center text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20">
                                <Loader2 className="size-4 ltr:mr-2 rtl:ml-2 animate-spin" />
                                Saving...
                            </button>
                        }

                    </div>
                </form>
            </Modal.Body>
        </React.Fragment>
    )
}

export default AddGTSRate;